import { withTheme } from '@rjsf/core';
import { Theme as shadcnTheme } from '@rjsf/shadcn';

export const ShadcnForm = withTheme(shadcnTheme);
